import { withStyles } from '@material-ui/core'
import { ToggleButton } from '@material-ui/lab'
import { GRAY_COLORS } from '../../colors.constant'

export const AsterToggleButton = withStyles(theme => ({
  root: {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '6px !important',
    color: GRAY_COLORS[500],
    fontWeight: 600,
    fontSize: 14,
    margin: 0,
    padding: '8px 12px',

    '&.Mui-selected': {
      backgroundColor: 'white',
      color: GRAY_COLORS[700]
    }
  }
}))(ToggleButton)
